import { FC,useContext,useRef } from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../ag-grid.css'
import '../../../ag-theme-alpine.css'

import { Tooltip } from 'primereact/tooltip';

import { GrEdit } from "react-icons/gr";
import { HiOutlineTrash } from "react-icons/hi2";

import { UserContext } from "../../../Redux/UserContext";
import { error, success, warning } from "../../../utils/notifications";
import { IoEyeOutline } from "react-icons/io5";
import { catchResponse } from "../../../utils/helperFunctions";
import { deleteError } from "../../../services/errors-service";
import { TbTrashOff } from "react-icons/tb";

export const ErrorTable:FC<any> = (props) => {

    const {data} = props

    const gridRef :any= useRef();

    const {handleOpenEditModal, setSelectedError, setEditMode, flagErrors, setFlagErrors} = props

    const [state] = useContext(UserContext)

  
    const LinkCellRenderer:FC<any> = (props:any):JSX.Element => {


        const { data } = props

        const handleEditError = (e:any,params:any) => {
            setSelectedError(params)
            setEditMode(true)
            handleOpenEditModal()
        }

        const handleDeleteError = async(e:any,data:any) => {
            if(!(data.registrado_por) || data.registrado_por === "") {
                warning("No se puede eliminar un error perteneciente al planificador.")
            } else {
                try {
                    const res = await deleteError(data.idtipoerror)
                    if(res.status === 200) {
                        const {code,message} = res.data
                        if(code === 200) {
                            setFlagErrors(!flagErrors)
                            success(message)
                        } else {
                            error(message)
                        }
                    } else {
                        error("No se ha podido eliminar el error")
                    }
                } catch(err:any) {
                    catchResponse(err)
                }
            }
            
        }
        
        return (
            <button className="paymt__button">
                <Tooltip target=".custom-target-icon"  style={{fontSize:'0.75rem',fontFamily:'var(--roboto-light)'}}/>
                {
                    state?.rol_id !== 1 || (data.registrado_por === "" || data.registrado_por === null)?
                    <IoEyeOutline  
                    className="custom-target-icon"
                    data-pr-tooltip="Visualizar error"
                    data-pr-position="bottom"
                    
                    style={{fontSize:18,marginRight:'1rem'}} onClick={(e:any) => handleEditError(e,data)} />
                    :
                    <GrEdit  
                    className="custom-target-icon"
                    data-pr-tooltip="Editar error"
                    data-pr-position="bottom"
                    
                    style={{fontSize:18,marginRight:'1rem'}} onClick={(e:any) => handleEditError(e,data)} />
                }
                
                <Tooltip target=".custom-target-icon2" style={{fontSize:'0.75rem',fontFamily:'var(--roboto-light)'}} />
                {
                    (data.registrado_por === "" || data.registrado_por === null) || state?.rol_id !== 1?
                    <TbTrashOff 
                    className="custom-target-icon2"
                    data-pr-tooltip="Eliminar error"
                    data-pr-position="bottom"
                    
                    style={state?.rol_id !== undefined? [2,3,4,6].includes(state.rol_id) ? {fontSize:18,color:'gray',cursor:'default'} : {fontSize:18} : {fontSize:18,color:'lightgray',cursor:'default'}} onClick={state?.rol_id !== undefined? [2,3,4,6].includes(state.rol_id) ? () => {} : (e:any) => handleDeleteError(e,data) : () => {}} />
                    :
                    <HiOutlineTrash 
                    className="custom-target-icon2"
                    data-pr-tooltip="Eliminar error"
                    data-pr-position="bottom"
                    
                    style={state?.rol_id !== undefined? [2,3,4,6].includes(state.rol_id) ? {fontSize:18,color:'gray',cursor:'default'} : {fontSize:18} : {fontSize:18,color:'lightgray',cursor:'default'}} onClick={state?.rol_id !== undefined? [2,3,4,6].includes(state.rol_id) ? () => {} : (e:any) => handleDeleteError(e,data) : () => {}} />  
           
                }
                 </button>
        )
    }

    const handleCellStyleIE = (params:any) => {
        if((params.data.registrado_por === "") && params.column.colId === 'registrado_por' ) {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',borderRight:'1px solid #dee2e6',fontStyle:'italic'}
        }
        return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',borderRight:'1px solid #dee2e6',fontStyle:'normal'}
           
    }

    const dateCellRenderer = (params:any) => {
        if(params.value === null) {
            return '-'
        } 
        return params.value
    }

    const registeredByCellRenderer = (params:any) => {
        if(params.value === null || params.value === "") {
            return 'Planificador'
        }
        return params.value
    }


    return (
        <div className="ag-theme-alpine" style={{display:'flex',flexDirection:'column', height:'85%', width: '95%' }}>

            <AgGridReact
                ref={gridRef}
                headerHeight={30}
                getRowHeight={() => 30}
                
                rowData={data}
                enableCellTextSelection>
                <AgGridColumn  resizable={true} flex={1} hide  field={"id"}></AgGridColumn>
                <AgGridColumn filter   sortable cellStyle={handleCellStyleIE} headerClass={"header-resize"}   suppressNavigable={true} hide  resizable={true} flex={1} headerName={"Error ID"} field={"idtipoerror"}></AgGridColumn>
                <AgGridColumn filter sortable cellStyle={handleCellStyleIE} headerClass={"header-resize"}   suppressNavigable={true}flex={1} headerName={"Nombre del error"} field={"nombreerror"}></AgGridColumn>
                <AgGridColumn filter  sortable cellStyle={handleCellStyleIE} headerClass={"header-resize"}   suppressNavigable={true} flex={2} headerName={"Descripción"} field={"descripcion"}></AgGridColumn>
                <AgGridColumn filter  sortable cellStyle={handleCellStyleIE} headerClass={"header-resize"}   suppressNavigable={true} flex={2} headerName={"Pasos a seguir"} hide field={"pasos"}></AgGridColumn>
                <AgGridColumn filter sortable cellStyle={handleCellStyleIE} headerClass={"header-resize"}   suppressNavigable={true} flex={1} cellRenderer={dateCellRenderer} headerName={"Fecha"} field={"fecha_error"}></AgGridColumn>
                <AgGridColumn filter sortable cellStyle={handleCellStyleIE} headerClass={"header-resize"}   suppressNavigable={true} flex={1} hide field={"id_user"}></AgGridColumn>
                <AgGridColumn filter sortable cellStyle={handleCellStyleIE} headerClass={"header-resize"}   suppressNavigable={true} flex={1} cellRenderer={registeredByCellRenderer} headerName={"Registrado por"} field={"registrado_por"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyleIE} headerClass={"header-resize"}   headerName={"Acciones"} flex={0.75} cellRenderer={LinkCellRenderer}></AgGridColumn>

            </AgGridReact>
        </div>
    )
}